export enum EColorPermission {
  Available = "3px solid rgb(114, 209, 135)", // Green solid
  Busy = "3px solid rgba(196, 49, 75, 1)", // Red solid
  CloseTime = "3px solid #7f7f7f", //Gray solid
  DefaultBorder = "3px solid #106ebe", //Blue solid
  PermissionAlert = "3px solid #C4314B", //Blue solid
}

export enum EColorPermissionFloorPlan {
  Available = "rgb(114, 209, 135)", // Green solid
  Busy = "rgba(196, 49, 75, 1)", // Red solid
  Disable = "#7f7f7f", //Gray solid
  Blue = "#106ebe", //Blue solid
  Selected = "rgb(236 215 19 / 87%)",
  Hover = "#cccccc"
}

export enum ETheme {
  Dark = "#000002",
  Light = "#000003"
}


export enum EThemeBackground {
  Dark = "#2A2D37",
  Light = "#ffff"
}

export enum EThemeColor {
  ColorNeutralForeground1Dark = "#ffffff",
  ColorNeutralForeground1Light = "#242424",
  ColorNeutralForeground4Dark = "#999999",
  ColorNeutralForeground4Light ="#707070",
  ColorBrandBackground2HoverLight = "#cfe4fa",
  ColorBrandBackground2HoverDark = "#0c3b5e",
  ColorNeutralForeground2BrandSelectedLight = "#0f6cbd",
  ColorNeutralForeground2BrandSelectedDark = "#479ef5",
  IconLightGey = "#424242"
}

export enum ETextPermission {
  AllowConflict = "You cannot book this resource because your meeting request conflicts with the resource's booking policies.",
  NotPermissionToBooking = "You do not have permission to book this resource.",
  AllowRecurringMeeting = "This resource does not allow booking of recurring meetings.",
  None = "You cannot book this resource",
  TentativeResource = "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval."
}

export enum ETextDescPermission {
  AllowConflict = "You cannot book this resource because your meeting request conflicts with the resource's booking policies.",
  BookingWindowInDay = "The resource cannot be booked {{day}} days in advanced.",
  MinimumDurationInMinutes = "Meeting duration cannot be shorter than {{time}} minutes long.",
  MaximumDurationInMinutes = "Meeting duration cannot be longer than {{time}} minutes long.",
  NotPermissionToBooking = "You do not have permission to book this resource.",
  AllowRecurringMeeting = "This resource does not allow booking of recurring meetings.",
  None = "You cannot book this resource",
  TentativeResource = "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval."
}

export enum ETextDescPermissionRecurringAvailability {
  AllowConflictRecurring = "This resource can be booked but any occurrences with conflicts the resource will not be booked.",
  BookingWindowInDay = "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked",
  MinimumDurationInMinutes = "This resource can be booked, but the meeting duration must be at least {{time}} minutes." ,
  MaximumDurationInMinutes = "This resource can be booked, but the meeting duration must not exceed {{time}} minutes." 
}

export const DEFAULT_TIMEZONE = "UTC";